import { useState } from 'react';

export const useProcessorState = () => {
  const [deletedProcessors, setDeletedProcessors] = useState<Set<string>>(new Set());
  const [tooltipStates, setTooltipStates] = useState<{ [key: string]: boolean }>({});
  const [merchantIds, setMerchantIds] = useState<{ [processorId: string]: string }>({});

  return {
    deletedProcessors,
    setDeletedProcessors,
    tooltipStates,
    setTooltipStates,
    merchantIds,
    setMerchantIds,
  };
};
